var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame21472253941(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 8,
    stroke: "#C0CDE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.5V10.5M10.5 10.5H18.5M10.5 10.5L15.5 17",
    stroke: "#C0CDE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame21472253941);
export default __webpack_public_path__ + "static/media/Frame 2147225394 (1).904374b61fc2495ea67db3656b602c23.svg";
export { ForwardRef as ReactComponent };